import { useRecoilState } from 'recoil';
import React, { useEffect, useState } from 'react';
import { UploadForm } from './UploadForm';
import { GoogleSheetForm } from './GoogleSheetForm';
import { Input } from 'antd';
import { DatabaseOutlined, GoogleOutlined } from '@ant-design/icons';

export { DBPortal };

  var upload_form_subject = [
    {
      title: 'Tên môn học',
      dataIndex: 'subject_name',
      key: 'subject_name',
    },
    {
      title: 'Mã môn học',
      dataIndex: 'subject_code',
      key: 'subject_code',
    },
    {
      title: 'Lỗi',
      dataIndex: 'error',
      key: 'error',
    },
  ];

  var upload_score_student = [
    {
        title: 'Mã học sinh',
        dataIndex: 'student_id',
        key: 'student_id',
    },
    {
        title: 'Mã kỹ năng',
        dataIndex: 'subject_code',
        key: 'subject_code',
    },
    {
        title: 'Loại điểm',
        dataIndex: 'score_type',
        key: 'score_type',
    },
    {
        title: 'Điểm',
        dataIndex: 'score',
        key: 'score',
    },
    {
        title: 'Lỗi',
        dataIndex: 'error',
        key: 'error',
    },
  ]
  var upload_form_student = [
    {
      title: 'Ngày sinh',
      dataIndex: 'date_of_birth',
      key: 'date_of_birth',
    },
    {
      title: 'Tên',
      dataIndex: 'name',
      key: 'name',
    },
    {
        title: 'Vai trò',
        dataIndex: 'role',
        key: 'role',
    },
    {
        title: 'Quê quán',
        dataIndex: 'location',
        key: 'location',
    },
    {
        title: 'Student ID',
        dataIndex: 'student_id',
        key: 'student_id',
    },
    {
        title: 'Username',
        dataIndex: 'username',
        key: 'username',
    },
    {
        title: 'Password',
        dataIndex: 'password',
        key: 'password',
    },
    {
        title: 'Giới tính',
        dataIndex: 'gender',
        key: 'gender',
    },
    {
        title: 'Số điện thoại',
        dataIndex: 'phone_number',
        key: 'phone_number',
    },
    {
      title: 'Lỗi',
      dataIndex: 'error',
      key: 'error',
    },
  ];
  // upload_form_teacher removed — teacher CSV upload is disabled.

  var upload_form_status = [
    {
        title: 'Student ID',
        dataIndex: 'student_id',
        key: 'student_id',
    },
    {
        title: 'Trạng thái',
        dataIndex: 'status',
        key: 'status',
    },

    {
        title: 'Lỗi',
        dataIndex: 'error',
        key: 'error',
    },

  ]

  // Column order matters: `note` must be second-to-last and `error` last, because
  // UploadForm.delError() strips the last column for the success table (keeps `note`).
  var upload_form_tuition = [
    { title: 'Mã học sinh',  dataIndex: 'student_id',     key: 'student_id'     },
    { title: 'Số buổi (gói)',dataIndex: 'lesson_quota',   key: 'lesson_quota'   },
    { title: 'Buổi còn lại', dataIndex: 'lessons_left',   key: 'lessons_left'   },
    { title: 'Giá gói',      dataIndex: 'price',          key: 'price'          },
    { title: 'Số tiền',      dataIndex: 'amount',         key: 'amount'         },
    { title: 'Ngày nộp',     dataIndex: 'payment_date',   key: 'payment_date'   },
    { title: 'Hình thức',    dataIndex: 'payment_method', key: 'payment_method' },
    { title: 'Kết quả',      dataIndex: 'note',           key: 'note'           },
    { title: 'Lỗi',          dataIndex: 'error',          key: 'error'          },
  ]
function DBPortal() {
    const [scoreClassId, setScoreClassId] = useState('');
    return (
        <div className="att2-page soft-in" style={{ overflowX: 'hidden' }}>
            <div className="att2-head">
                <div className="att2-head-l">
                    <h1 className="att2-title">Quản lý cơ sở dữ liệu</h1>
                    <div className="att2-sub">Nơi tải lên dữ liệu học sinh, điểm số dành cho Giáo viên</div>
                </div>
            </div>

            <div className="dbportal-grid">
                {/* Teacher CSV upload removed — teachers are created via the
                    "Thêm nhân sự" modal in Quản lý giáo viên. */}

                <div className="upload-tile">
                    <div className="dbportal-tile-title">Danh sách học sinh</div>
                    <i>Tải danh sách tài khoản và thông tin học sinh lên hệ thống.</i>
                    <br/><br/><UploadForm columns={upload_form_student} formurl="/api/upload/dssv"/>
                    <br/><i><b>Lưu ý:</b> Các học sinh sẽ chưa được thêm lớp. Yêu cầu GV tạo lớp và thêm tại bảng Thông tin SV.</i>
                </div>

                <div className="upload-tile">
                    <div className="dbportal-tile-title">Danh sách kỹ năng</div>
                    <i>Tải danh sách kỹ năng tiếng Anh lên hệ thống (Reading, Listening, Writing, Speaking).</i>
                    <br/><br/><UploadForm columns={upload_form_subject} formurl="/api/upload/dsmh"/>
                </div>

                <div className="upload-tile">
                    <div className="dbportal-tile-title">Cập nhật bảng điểm</div>
                    <i>Tải danh sách bảng điểm của học sinh lên hệ thống.</i>
                    <br/><br/>
                    <Input
                      placeholder="Mã lớp học (ví dụ: E001)"
                      value={scoreClassId}
                      onChange={e => setScoreClassId(e.target.value)}
                      style={{ marginBottom: 8 }}
                    />
                    <i className="dbportal-tile-note">Bắt buộc nhập mã lớp trước khi tải điểm lên.</i>
                    <br/><br/>
                    <UploadForm columns={upload_score_student} formurl="/api/scores/import" extraFormData={{ class_id: scoreClassId }}/>
                </div>

                <div className="upload-tile">
                    <div className="dbportal-tile-title">Học phí &amp; gói buổi học</div>
                    <i>Nhập dữ liệu học phí cũ: gói buổi học, số buổi còn lại và lịch sử thanh toán.</i>
                    <br/>
                    <i className="dbportal-tile-note">
                        Cột: <b>student_id, lesson_quota, lessons_left, price, amount, payment_date, payment_method, notes</b>.
                        Một dòng / học sinh; có thể lặp lại <b>student_id</b> để thêm nhiều lần nộp.
                        <b>price</b> = tổng giá gói học (để trống = 0); còn nợ = giá gói − tổng đã nộp.
                        Hình thức: <b>T</b> = Tiền mặt, <b>C</b> = Chuyển khoản. Ngày: YYYY-MM-DD hoặc DD/MM/YYYY.
                    </i>
                    <br/>
                    <i className="dbportal-tile-note" style={{ color: 'var(--warn)' }}>
                        ⚠ Khi lưu từ Excel, chọn định dạng <b>"CSV UTF-8 (Comma delimited) (.csv)"</b> để
                        không bị lỗi tiếng Việt (Đợt, Bảo lưu, tên có dấu…).
                    </i>
                    <br/><br/><UploadForm columns={upload_form_tuition} formurl="/api/upload/tuition"/>
                </div>

                <div className="upload-tile">
                    <div className="dbportal-tile-title"><GoogleOutlined /> Import từ Google Sheets</div>
                    <i>Dán link Google Sheets (chia sẻ công khai) để import trực tiếp, không cần tải file CSV.</i>
                    <br/><br/>
                    <GoogleSheetForm />
                </div>
            </div>

        </div>
    )
}